import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateMessageTemplatePayload } from 'api/MessageTemplatesApi';
import { MessageTemplatesApi } from 'api/MessageTemplatesApi';
import { MESSAGE_TEMPLATES_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useUpdateMessageTemplate() {
  const messageTemplatesApi = new MessageTemplatesApi();
  const { userBankId } = useUser();
  const queryClient = useQueryClient();

  const { mutateAsync: updateMessageTemplate, isPending: isUpdatingMessageTemplate } = useMutation({
    mutationKey: [MESSAGE_TEMPLATES_KEY, 'update'],
    mutationFn: ({ id, ...data }: UpdateMessageTemplatePayload & { id: string }) =>
      messageTemplatesApi.updateMessageTemplate(userBankId, id, data),
    onSuccess: () => {
      // Refetch every cached list variant for this bank so the Library reflects the new
      // content / status / last_modified (prefix match on the query key).
      queryClient.invalidateQueries({ queryKey: [MESSAGE_TEMPLATES_KEY, userBankId] });
    },
    meta: {
      snackbarSuccessMessage: 'Template saved.',
      snackbarErrorMessage: 'There was an issue saving the template. Please contact support.'
    }
  });

  return { updateMessageTemplate, isUpdatingMessageTemplate };
}
